if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector("form");
				this.form.querySelector("[name=id]").disabled = false;
				this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
				this.cart =
					document.querySelector("cart-notification") ||
					document.querySelector("cart-drawer");
				this.submitButton = this.querySelector('[type="submit"]');
				if (document.querySelector("cart-drawer"))
					this.submitButton.setAttribute("aria-haspopup", "dialog");

				this.hideErrors = this.dataset.hideErrors === "true";
			}

			onSubmitHandler(evt) {
				evt.preventDefault();
				if (this.submitButton.getAttribute("aria-disabled") === "true") return;

				this.handleErrorMessage();

				this.submitButton.setAttribute("aria-disabled", true);
				this.submitButton.classList.add("loading");
				const spinner = this.querySelector(".loading-overlay__spinner");
				if (spinner) spinner.classList.remove("hidden");

				const config = fetchConfig("javascript");
				config.headers["X-Requested-With"] = "XMLHttpRequest";
				delete config.headers["Content-Type"];

				const formData = new FormData(this.form);
				if (this.cart) {
					formData.append(
						"sections",
						this.cart.getSectionsToRender().map((section) => section.id)
					);
					formData.append("sections_url", window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}
				config.body = formData;

				fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							document.dispatchEvent(
								new CustomEvent("cart:error", {
								  detail: {
									source: "product-form",
									productVariantId: formData.get("id"),
									errors: response.description,
									message: response.message,
								  },
								})
							);
							// -------------------------------------------
							publish(PUB_SUB_EVENTS.cartError, {
								source: "product-form",
								productVariantId: formData.get("id"),
								errors: response.description,
								message: response.message,
							});
							this.handleErrorMessage(response.description);

							// Open cart drawer when cart was partially updated (e.g. availability message)
							if (this.cart && typeof this.cart.renderContents === "function") {
								this.error = false; // Keep add-to-cart usable after partial add
								if (response.sections) {
									this.cart.renderContents(response);
								} else {
									// Shopify 422 often omits sections; fetch via Section Rendering API
									const sectionIds = this.cart.getSectionsToRender().map((s) => s.id).join(",");
									const url = `${routes.cart_url}?sections=${sectionIds}`;
									fetch(url)
										.then((res) => res.json())
										.then((sections) => this.cart.renderContents({ sections }));
								}
							}

							const soldOutMessage =
								this.submitButton.querySelector(".sold-out-message");
							if (!soldOutMessage) return;
							this.submitButton.setAttribute("aria-disabled", true);
							this.submitButton.querySelector("span").classList.add("hidden");
							soldOutMessage.classList.remove("hidden");
							this.error = true;
							return;
						} else if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}

						// VARIANT ADDED EVENT
						document.dispatchEvent(
							new CustomEvent("variant:add", {
							  detail: {
								variant: {
								  id: formData.get("id"),
								},
								quantity: Number(formData.get("quantity") || 1),
								formElement: this.form,
								sectionId: this.dataset.source,
							  },
							})
						  );
						  // -------------------------------------------

						  fetch(`${routes.cart_url}.js`)
							.then((response) => {
								return response.text()
							})
							.then((state) => {
								const parsedState = JSON.parse(state)

								// dispatch cart:change for the entire basket
								document.dispatchEvent(
									new CustomEvent('cart:change', {
										detail: {
											cart: parsedState,
											sectionId: this.dataset.source,
										},
									})
								)
								// dispatch cart:change for the entire basket

							})
							.catch((error) => {
								console.error('Error fetching cart state:', error);
							})
				
						  if (!this.error) {
							publish(PUB_SUB_EVENTS.cartUpdate, {
							  source: "product-form",
							  productVariantId: formData.get("id"),
							});
						}
						this.error = false;
						const quickAddModal = this.closest("quick-add-modal");
						if (quickAddModal) {
							document.body.addEventListener(
								"modalClosed",
								() => {
									setTimeout(() => {
										this.cart.renderContents(response);
									});
								},
								{ once: true }
							);
							quickAddModal.hide(true);
						} else {
							this.cart.renderContents(response);
						}
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						this.submitButton.classList.remove("loading");
						if (this.cart && this.cart.classList.contains("is-empty"))
							this.cart.classList.remove("is-empty");
						if (!this.error) this.submitButton.removeAttribute("aria-disabled");
						if (spinner) spinner.classList.add("hidden");
					});
			}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;

				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					this.querySelector(".product-form__error-message-wrapper");
				if (!this.errorMessageWrapper) return;
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector(
						".product-form__error-message"
					);

				this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		}
	);
}
